module.exports = __webpack_public_path__ + "img/ctkjbanner1.1a262edf.png";